import { useQuery } from '@tanstack/react-query';
import type { CMSForm as CMSFormType } from '../schemas';
import { cmsQueryKeys } from '@/services/cms/cmsQueryKeys';
import { getCMSForm } from '@/services/cms/getCMSForm';
import { FullScreenLoadingSpinner } from '@/components/full-screen-loading-spinner';
import { CMSFormBuilder } from './cms-form-builder';
import React from 'react';
import { SCROLLABLE_IDS } from '@/constants/app.constants';

interface CMSFormProps {
  formData: CMSFormType;
}
const CMSForm = ({ formData }: CMSFormProps) => {
  const handle = formData.form.handle;
  const { data, isPending, isError } = useQuery({
    queryKey: cmsQueryKeys.getCMSForm(handle),
    queryFn: () => getCMSForm(handle),
    staleTime: Infinity,
  });

  //NOTE: if page hasn't been loaded yet it will have problem scrolling it using hash
  React.useEffect(() => {
    if (isPending && data) {
      return;
    }

    const hash = window.location.hash;
    if (!hash) {
      return;
    }

    const replacedHash = hash.replace('#', '');
    if (replacedHash !== SCROLLABLE_IDS.FORMS) {
      return;
    }

    const form = document.getElementById(SCROLLABLE_IDS.FORMS);
    if (!form) {
      return;
    }

    form.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }, [isPending, data]);

  if (isPending) {
    return <FullScreenLoadingSpinner />;
  }
  if (isError) {
    return null;
  }

  return (
    <CMSFormBuilder
      formData={{ formFields: data.formFields, meta: data.meta }}
    />
  );
};

export { CMSForm };
